import { makeVar, useReactiveVar } from "@apollo/client";

interface ISelectedStreamObject {
  streamName: string;
  extractedDeviceName: string;
  nodeId: string;
}

export const selectedStreamObjectVariable =
  makeVar<ISelectedStreamObject | null>(null);

export const useSelectedStreamObject = () =>
  useReactiveVar(selectedStreamObjectVariable);

export const openPTConctollerVariable = makeVar(false);

export const useOpenPTConctoller = () =>
  useReactiveVar(openPTConctollerVariable);
